export const iconFontAwesomeClothingFashionUserTie = (
	<i className="fa-solid fa-user-tie"></i>
);
